import Block from "./Block";

interface CanvasBlockSource {
  id: string;
  source: Block;
  canvas?: HTMLCanvasElement;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export default class CanvasBlock {
  public id: string;
  public source: Block;

  public x: number;
  public y: number;
  public width: number;
  public height: number;
  public calculated: { x: number; y: number; width: number; height: number };

  private canvas?: HTMLCanvasElement;
  private fill: string;
  private ratio = 1;

  constructor(options: CanvasBlockSource) {
    this.id = options.id;
    this.source = options.source;
    this.canvas = options.canvas || undefined;

    this.x = options.x || options.source.left || 0;
    this.y = options.y || options.source.top || 0;
    this.width =
      options.width || options.source.right - options.source.left || 1;
    this.height =
      options.height || options.source.bottom - options.source.top || 1;
    this.fill = options.source.isChecked ? "blue" : options.fill || "green";
  }

  get isChecked(): boolean {
    return this.source.isChecked;
  }

  get isRenderable(): boolean {
    if (!this.canvas) {
      return false;
    }
    const { x, y, width, height } = this.calculated;
    return (
      x > this.canvas.width ||
      y > this.canvas.height ||
      x + width < 0 ||
      y + height < 0
    );
  }

  public setChecked(isChecked: boolean) {
    this.source.isChecked = isChecked;
  }

  public setRatio(ratio: number) {
    this.ratio = ratio;
    this.calculated = {
      x: this.getRatioCalculatedValue(this.x),
      y: this.getRatioCalculatedValue(this.y),
      width: this.getRatioCalculatedValue(this.width),
      height: this.getRatioCalculatedValue(this.height),
    };
  }

  public draw(ctx: CanvasRenderingContext2D) {
    const { x, y, width, height } = this.calculated;
    ctx.fillStyle = this.fill;
    ctx.fillRect(x, y, width, height);
  }

  public stroke(ctx: CanvasRenderingContext2D) {
    const { x, y, width, height } = this.calculated;
    ctx.strokeStyle = this.fill;
    ctx.lineWidth = 1;
    ctx.strokeRect(x, y, width, height);
  }

  public contains(mouseX: number, mouseY: number) {
    const { x, y, width, height } = this.calculated;
    return (
      x <= mouseX && x + width >= mouseX && y <= mouseY && y + height >= mouseY
    );
  }

  private getRatioCalculatedValue(v: number): number {
    return v * this.ratio;
  }
}
